import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/portfolio/")({
  beforeLoad: () => {
    throw redirect({
      to: "/portfolio/assets",
    });
  },
});
